// Shared helpers for chat DataTable bulk-select and bulk-remove actions.
// Used by chat--history, chat--bans--index, and chat--rules--index controllers.

// pathResolver: either a string (static path) or a function returning a string.
// Falls back to legacy page_args / location-based resolution for backward compat.
export function initRemoveItemsHandler(name, table, namespace = "chatBulk", pathResolver = null) {
  $(document).on(`click.${namespace}`, `a.${name}-remove`, function () {
    const groupName = $(`input#check-all-${name}`).val()
    const checkboxes = $(`input[name^='${groupName}']:checked`)
    const available = $(`input[name^='${groupName}']`)
    const allChecked = checkboxes.length === available.length

    if (!available.length) return false
    if (!checkboxes.length) {
      alert("Please select at least one item")
      return false
    }
    if (!confirm("Are you sure? All selected items will be removed")) return false

    let path
    if (pathResolver) {
      path = typeof pathResolver === "function" ? pathResolver() : pathResolver
    } else if (name === "bans") {
      path = document.location.pathname + "/remove"
    } else if (name === "usertriggers") {
      path = document.location.pathname + "/remove?data=trigger"
    }

    if (!path) return false

    $(".dataTables_processing").css("display", "block")

    const ids = $.makeArray(
      checkboxes.map(function () {
        return $(this).val()
      }),
    )

    $.delete(path, { item_ids: ids }, function () {
      const settings = table.settings()[0]
      if (allChecked && settings._iRecordsDisplay - settings._iDisplayStart <= settings._iDisplayLength) {
        table.page("previous").draw(false)
      } else {
        table.draw(false)
      }
      $(".dataTables_processing").css("display", "none")
    })

    $(`#check-all-${name}`).prop("checked", false)
  })
}

export function checkboxesGroupController(groupName, namespace = "chatBulk") {
  const groupSelector = `input#check-all-${groupName}`
  const checkboxSelector = `#${groupName}_list tbody input[type="checkbox"]`

  $(groupSelector).on(`change.${namespace}`, function () {
    $(checkboxSelector).prop("checked", $(groupSelector).is(":checked"))
  })

  $(checkboxSelector).on(`change.${namespace}`, function () {
    let allChecked = true
    $(checkboxSelector).each(function () {
      if (!this.checked) allChecked = false
    })
    $(groupSelector).prop("checked", allChecked)
  })
}
